import { ROUTES } from '@analyzer/utils/router/paths'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/$workspaceId/comparison/$comparisonId/'
)({
  beforeLoad({ params }) {
    throw redirect({ to: ROUTES.comparisonText, params })
  },
})
